import React, { useState, useEffect, useCallback, useRef } from 'react';
import { FaPlay, FaPlusCircle, FaSearch, FaMinusCircle,FaArrowLeft } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import '@styles/GeneralPages.css';
import '@styles/Workout.css';
import '@styles/Workout.css';
import { resetExercisePerformanceStore, getIndexedDBData, saveCurrentWorkoutSession,
  getMaxSessionId, getMaxTemplateId, getCurrentWorkoutSession,
  saveCurrentWorkoutLog, getCurrentWorkoutLogs, updateCurrentWorkoutLog,
  saveCurrentSet, getCurrentSets, updateCurrentSet, clearCurrentWorkoutData, loadActiveWorkoutFromDB,
  getWorkoutTemplatesExercises, formatExerciseList, deleteCurrentSet, getLastExercisePerformance, 
  saveLastExercisePerformance, cleanupExercisePerformanceData, saveExerciseMuscles, deleteWorkoutTemplate, addNewCustomExercise } from '@utility/workout_utils.js'
import WorkoutTimer from '@components/workout_page/WorkoutTimer';
import { openDB } from '@utility/indexedDB_utils'
import { getCurrentUTCDate } from '@utility/common_utils';
await resetExercisePerformanceStore();

const Workout = () => {
  const [showNewExerciseForm, setShowNewExerciseForm] = useState(false);
  const [workoutTemplates, setWorkoutTemplates] = useState([]);
  const [expandedWorkout, setExpandedWorkout] = useState(null);
  const [workoutTemplatesExercises, setWorkoutTemplatesExercises] = useState([]);
  const [exercises, setExercises] = useState([]);
  const [primaryMuscles, setPrimaryMuscles] = useState([]);
  const [secondaryMuscles, setSecondaryMuscles] = useState([]);
  const [activeWorkout, setActiveWorkout] = useState(null);
  const [showAddExerciseModal, setShowAddExerciseModal] = useState(false);
  const [exerciseSearchTerm, setExerciseSearchTerm] = useState('');
  const [startWorkoutDate, setStartWorkoutDate] = useState(null);
  const [newExerciseData, setNewExerciseData] = useState({
    name: '',
    is_isolated: false,
    category: 'Freeweight',
    primaryMuscles: [],
    secondaryMuscles: []
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const [updatedWorkoutName, setUpdatedWorkoutName] = useState('');
  const [templateAction, setTemplateAction] = useState('none');
  const [originalTemplate, setOriginalTemplate] = useState(null);
  const [templateChanges, setTemplateChanges] = useState({
    exercisesAdded: 0,
    exercisesRemoved: 0,
    setsChanged: 0
  });
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [editedTemplate, setEditedTemplate] = useState({
    name: '',
    description: '',
    exercises: []
  });
  const [showTemplateEditor, setShowTemplateEditor] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [currentExerciseNotes, setCurrentExerciseNotes] = useState('');
  const [currentExerciseIndex, setCurrentExerciseIndex] = useState(null);
  const [showExerciseModal, setShowExerciseModal] = useState(false);
  const [exerciseModalContext, setExerciseModalContext] = useState(null);
  const [muscles, setMuscles] = useState([]);
  const [selectedPrimaryMuscles, setSelectedPrimaryMuscles] = useState([]);
  const [selectedSecondaryMuscles, setSelectedSecondaryMuscles] = useState([]);
  const exerciseListRef = useRef(null);
  const filteredExercises = exercises.filter(exercise =>
    exercise.name.toLowerCase().includes(exerciseSearchTerm.toLowerCase())
  );
  const exerciseListScrollPosition = useRef(0);
  const [selectedExercises, setSelectedExercises] = useState([]);
  const [hasActiveWorkout, setHasActiveWorkout] = useState(false);
  const totalPages = 3; // for the exercise form
  const totalPagesT = 2;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageT, setCurrentPageT] = useState(1);
  const [isNewTemplate, setIsNewTemplate] = useState(false);


  const goToNextPageT = () => {
      if (currentPageT < totalPagesT) {
        setCurrentPageT(currentPageT + 1);
      }
    };

  const goToPreviousPageT = () => {
    if (currentPageT > 1) {
      setCurrentPageT(currentPageT - 1);
    }
  };


  const renderTemplatePage = () => {
    switch (currentPageT) {
      case 1:
        return (
          <div className="form-page">
            {!isNewTemplate ? (
              <>
                <div className="center">
                  <h2>Edit Workout Template</h2>
                </div>
                <div className="center">
                  <button
                    onClick={async () => {
                      if (window.confirm("Are you sure you want to delete this template?")) {
                        try {
                          await deleteWorkoutTemplate(editedTemplate.id);
                          // Refresh templates
                          const [updatedTemplates, updatedTemplateExercises] = await Promise.all([
                            getIndexedDBData("workout_templates"),
                            getIndexedDBData("workout_template_exercises")
                          ]);
                          setWorkoutTemplates(updatedTemplates);
                          setWorkoutTemplatesExercises(updatedTemplateExercises);
                          setShowTemplateEditor(false);
                          setEditingTemplate(null);
                        } catch (error) {
                          console.error("Error deleting template:", error);
                          setError("Failed to delete template");
                        }
                      }
                    }}
                    className="exercise-action-button delete-template"
                  >
                    Delete Template
                  </button>
                </div>
              </>
            ) : (
              <div className="center">
                <h2>New Workout Template</h2>
              </div>
            )}
            
            <div className="form-group">
              <h3 className="sub-titles">Template Name:</h3>
              <textarea
                className="edit-workout"
                value={editedTemplate.name}
                onChange={(e) => setEditedTemplate({
                  ...editedTemplate,
                  name: e.target.value
                })}
                rows="1"
              />
            </div>

            <div className="form-group">
              <h3 className="sub-titles">Description:</h3>
              <textarea
                value={editedTemplate.description}
                onChange={(e) => setEditedTemplate({
                  ...editedTemplate,
                  description: e.target.value
                })}
                rows="3"
              />
            </div>

            <div className="modal-actions">
              <button
                onClick={() => {
                  setShowTemplateEditor(false);
                  setEditingTemplate(null);
                  setIsNewTemplate(false);
                }}
                className="exercise-action-button delete-exercise"
              >
                Cancel
              </button>
              <button
                onClick={goToNextPageT}
                className="exercise-action-button add-set"
              >
                Next
              </button>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="form-page">
            <h2 className="sub-titles">Exercises</h2>
            {editedTemplate.exercises.map((exercise, exIndex) => (
              <div key={exIndex} className="exercise-item">
                <div className="exercise-header">
                  <h3>{exercise.name}</h3>
                </div>

                <table className="sets-table">
                  <thead>
                    <tr>
                      <th>Set</th>
                      <th>Kg</th>
                      <th>Reps</th>
                      <th>ROM</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {exercise.sets.map((set, setIndex) => (
                      <tr key={setIndex}>
                        <td 
                          className={`set-number ${set.drop_set_group > 0 ? 'drop-set' : ''}`}
                          onClick={() => handleTemplateSetNumberClick(exIndex, setIndex)}
                        >
                          {set.drop_set_group > 0 ? 'D' : set.setNumber}
                        </td>
                        <td>
                          <input
                            type="number"
                            value={set.weight}
                            onChange={(e) => {
                              const newExercises = [...editedTemplate.exercises];
                              newExercises[exIndex].sets[setIndex].weight =
                                parseFloat(e.target.value) || 0;
                              setEditedTemplate({
                                ...editedTemplate,
                                exercises: newExercises
                              });
                            }}
                            className="weight-input"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            value={set.reps}
                            onChange={(e) => {
                              const newExercises = [...editedTemplate.exercises];
                              newExercises[exIndex].sets[setIndex].reps =
                                parseInt(e.target.value) || 0;
                              setEditedTemplate({
                                ...editedTemplate,
                                exercises: newExercises
                              });
                            }}
                            className="reps-input"
                          />
                        </td>
                        <td>
                          <button
                            onClick={() => handleTemplateSetPartial(exIndex, setIndex)}
                            className={`partial-button ${set.partial ? 'active' : ''}`}
                          >
                            {set.partial ? 'P' : 'F'}
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() => {
                              const newExercises = [...editedTemplate.exercises];
                              newExercises[exIndex].sets.splice(setIndex, 1);
                              // Update set numbers
                              newExercises[exIndex].sets.forEach((s, i) => {
                                s.setNumber = i + 1;
                              });
                              setEditedTemplate({
                                ...editedTemplate,
                                exercises: newExercises
                              });
                            }}
                            className="delete-set-button"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="exercise-actions">
                  <button
                    onClick={() => {
                      const newExercises = [...editedTemplate.exercises];
                      newExercises.splice(exIndex, 1);
                      setEditedTemplate({ ...editedTemplate, exercises: newExercises });
                    }}
                    className="exercise-action-button delete-exercise"
                  >
                    Remove Exercise
                  </button>
                  <button
                    onClick={() => {
                      const newExercises = [...editedTemplate.exercises];
                      newExercises[exIndex].sets.push({
                        setNumber: newExercises[exIndex].sets.length + 1,
                        weight: 0,
                        reps: 0
                      });
                      setEditedTemplate({
                        ...editedTemplate,
                        exercises: newExercises
                      });
                    }}
                    className="exercise-action-button add-set"
                  >
                    Add Set
                  </button>
                </div>
              </div>
            ))}

            <div className="template-editor-add-exercise">
              <button
                onClick={() => openAddExerciseModal('template')}
                className="complete-workout-button"
              >
                <FaPlusCircle /> Add Exercise
              </button>
            </div>

            <div className="modal-actions">
              <button
                onClick={goToPreviousPageT}
                className="exercise-action-button delete-exercise"
              >
                Back
              </button>
              <button
                onClick={() => {
                  saveTemplateChanges();
                  setIsNewTemplate(false);
                }}
                className="exercise-action-button add-set"
              >
                Save Changes
              </button>
            </div>
          </div>
        );  
      default:
        return null;
    }
  };

  const saveTemplateChanges = async () => {
    try {
        const db = await openDB();
        
        // Clear existing exercises - with fallback if index doesn't exist
        await new Promise((resolve, reject) => {
            const transaction = db.transaction(["workout_template_exercises"], "readwrite");
            const store = transaction.objectStore("workout_template_exercises");
            
            // Try using index first
            if (store.indexNames.contains("template_id")) {
                const index = store.index("template_id");
                const clearRequest = index.openCursor(IDBKeyRange.only(editedTemplate.id));
                
                clearRequest.onsuccess = (e) => {
                    const cursor = e.target.result;
                    if (cursor) {
                        cursor.delete();
                        cursor.continue();
                    } else {
                        resolve();
                    }
                };
            } else {
                // Fallback to manual filtering
                const getAllRequest = store.getAll();
                getAllRequest.onsuccess = (e) => {
                    const allItems = e.target.result;
                    const deleteRequests = allItems
                        .filter(item => item.template_id === editedTemplate.id)
                        .map(item => {
                            return new Promise((innerResolve, innerReject) => {
                                const deleteRequest = store.delete(item.id);
                                deleteRequest.onsuccess = innerResolve;
                                deleteRequest.onerror = innerReject;
                            });
                        });
                    
                    Promise.all(deleteRequests).then(resolve).catch(reject);
                };
            }
            
            transaction.onerror = (error) => {
                console.error("Clear error:", error);
                reject(error);
            };
        });

        // Save updated template
        await new Promise((resolve, reject) => {
            const transaction = db.transaction(
                ["workout_templates", "workout_template_exercises"],
                "readwrite"
            );

            // Update template details
            const templateStore = transaction.objectStore("workout_templates");
            templateStore.put({
                id: editedTemplate.id,
                name: editedTemplate.name,
                description: editedTemplate.description
            });

            // Add all new exercises
            const exercisesStore = transaction.objectStore("workout_template_exercises");
            editedTemplate.exercises.forEach((exercise, index) => {
                exercisesStore.add({
                    id: `${editedTemplate.id}-${exercise.id}-${index}`,
                    template_id: editedTemplate.id,
                    exercise_id: exercise.id,
                    sets_count: exercise.sets.length,
                    set_details: exercise.sets.map(set => ({
                        weight: set.weight,
                        reps: set.reps,
                        partial: set.partial || false,
                        drop_set_group: set.drop_set_group || 0
                    })),
                    exercise_index: index
                });
            });

            transaction.oncomplete = resolve;
            transaction.onerror = (error) => {
                console.error("Transaction error:", error);
                reject(error);
            };
        });

        // Refresh data
        const [updatedTemplates, updatedTemplateExercises] = await Promise.all([
            getIndexedDBData("workout_templates"),
            getIndexedDBData("workout_template_exercises")
        ]);

        setWorkoutTemplates(updatedTemplates);
        setWorkoutTemplatesExercises(updatedTemplateExercises);
        setShowTemplateEditor(false);
        setEditingTemplate(null);

    } catch (error) {
        console.error("Error saving template changes:", error);
        setError("Failed to save template changes. Please refresh the page and try again.");
    }
    setCurrentPageT(1);
  };

  useEffect(() => {
    let isMounted = true;

    const initialize = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // First check for active workout
        const activeWorkout = await loadActiveWorkoutFromDB();
        if (isMounted) {
          setHasActiveWorkout(!!activeWorkout);
          
          // Then load all the static data (templates, exercises, etc.)
          const [
            templates,
            templateExercises,
            exercisesData,
            primaryMusclesData,
            secondaryMusclesData,
            musclesData
          ] = await Promise.all([
            getIndexedDBData("workout_templates"),
            getIndexedDBData("workout_template_exercises"),
            getIndexedDBData("exercises"),
            getIndexedDBData("exercise_primary_muscles"),
            getIndexedDBData("exercise_secondary_muscles"),
            getIndexedDBData("muscles")
          ]);

          if (isMounted) {
            setWorkoutTemplates(templates);
            setWorkoutTemplatesExercises(templateExercises);
            setExercises(exercisesData);
            setPrimaryMuscles(primaryMusclesData);
            setSecondaryMuscles(secondaryMusclesData);
            setMuscles(musclesData);

            // Set active workout if found
            if (activeWorkout) {
              setActiveWorkout(activeWorkout);
            }
          }
        }
      } catch (err) {
        if (isMounted) {
          setError("Failed to load workout data. Please try again.");
          console.error("Initialization error:", err);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    initialize();

    return () => {
      isMounted = false;
    };
  }, []);

  // for scroll on exercise list (adding exercise)
  // save
  useEffect(() => {
    if (showAddExerciseModal && exerciseListRef.current) {
      // Save current scroll position when modal opens
      exerciseListScrollPosition.current = exerciseListRef.current.scrollTop;
    }
  }, [showAddExerciseModal]);

  // restore
  useEffect(() => {
    if (showAddExerciseModal && exerciseListRef.current && filteredExercises.length > 0) {
      // Restore scroll position after list is rendered
      exerciseListRef.current.scrollTop = exerciseListScrollPosition.current;
    }
  }, [filteredExercises, showAddExerciseModal]);

  const handleExerciseListScroll = () => {
    if (exerciseListRef.current) {
      exerciseListScrollPosition.current = exerciseListRef.current.scrollTop;
    }
  };


  const toggleWorkoutDescription = (id) => {
    setExpandedWorkout(expandedWorkout === id ? null : id);
  };

  const startNewWorkout = async (workoutType) => {
    try {
      await clearCurrentWorkoutData();
      setActiveWorkout(null);
      setStartWorkoutDate(new Date());

      if (workoutType === "empty") {
        await handleStartExistingWorkout("empty-workout");
      } else {
        await handleStartExistingWorkout(workoutType);
      }
    } catch (error) {
      setError("Failed to start new workout");
      console.error("Error starting new workout:", error);
    }
  };

  const handleStartExistingWorkout = async (id) => {
    try {
      await clearCurrentWorkoutData();
      setActiveWorkout(null);
      setStartWorkoutDate(new Date());
      if (id === "empty-workout") {
        const sessionData = {
          session_name: "Freestyle Workout",
          session_date: new Date().toISOString(),
          duration: 0
        };

        const sessionId = await saveCurrentWorkoutSession(sessionData);

        setActiveWorkout({
          id: sessionId,
          name: sessionData.session_name,
          exercises: [],
          startedAt: sessionData.session_date
        });
        return;
      }

      const template = workoutTemplates.find(t => t.id === id);
      if (!template) {
        setError("Workout template not found");
        return;
      }

      const sessionData = {
        session_name: template.name,
        session_date: new Date().toISOString(),
        duration: 0
      };

      const sessionId = await saveCurrentWorkoutSession(sessionData);
      const templateExercises = getWorkoutTemplatesExercises(workoutTemplatesExercises, id);

      const workoutExercises = await Promise.all(templateExercises.map(async (exercise, exIndex) => {
        const logEntry = {
          session_id: sessionId,
          exercise_id: exercise.exercise_id,
          sets_count: exercise.sets_count,
          total_weight_lifted: 0,
          notes: "",
          exercise_index: exIndex
        };

        const logId = await saveCurrentWorkoutLog(logEntry);

        await Promise.all(exercise.set_details.map(set =>
          saveCurrentSet({
            workout_log_id: logId,
            weight: set.weight,
            reps: set.reps,
            drop_set_group: set.drop_set_group || 0,
            partial: set.partial || false,
            completed: false,
            drop_set_group: set.drop_set_group || 0
          })
        ));

        return {
          id: exercise.exercise_id,
          name: exercises.find(e => e.id === exercise.exercise_id)?.name || `Exercise ${exercise.exercise_id}`,
          sets: exercise.set_details.map((set, i) => ({
            setNumber: i + 1,
            targetWeight: set.weight,
            targetReps: set.reps,
            completedWeight: null,
            completedReps: null,
            completed: false,
            partial: set.partial || false,
            drop_set_group: set.drop_set_group || 0
          }))
        };
      }));

      setActiveWorkout({
        id: sessionId,
        name: template.name,
        exercises: workoutExercises,
        startedAt: sessionData.session_date
      });
    } catch (error) {
      setError("Failed to start workout");
      console.error("Error starting workout:", error);
    }
};

  const handleAddExercise = async (exerciseId) => {
    try {
      if (!activeWorkout) return;

      const exerciseToAdd = exercises.find(ex => ex.id === exerciseId);
      if (!exerciseToAdd) return;

      const scrollPosition = exerciseListRef.current?.scrollTop;

      const lastPerformance = await getLastExercisePerformance(exerciseId);
      const defaultSets = lastPerformance?.sets || [{ weight: 0, reps: 0, partial: false }];

      const logEntry = {
        session_id: activeWorkout.id,
        exercise_id: exerciseToAdd.id,
        sets_count: 1,
        total_weight_lifted: 0,
        notes: "",
        exercise_index: activeWorkout.exercises.length
      };

      const logId = await saveCurrentWorkoutLog(logEntry);

      await Promise.all(defaultSets.map(set =>
        saveCurrentSet({
          workout_log_id: logId,
          weight: set.weight,
          reps: set.reps,
          drop_set_group: set.drop_set_group || 0,
          partial: set.partial || false,
          completed: false
        })
      ));

      const updatedWorkout = { ...activeWorkout };
      updatedWorkout.exercises.push({
        id: exerciseToAdd.id,
        name: exerciseToAdd.name,
        sets: defaultSets.map((set, i) => ({
          setNumber: i + 1,
          targetWeight: set.weight,
          targetReps: set.reps,
          completedWeight: null,
          completedReps: null,
          completed: false,
          partial: set.partial || false,
          drop_set_group: set.drop_set_group || 0
        }))
      });

      setActiveWorkout(updatedWorkout);
      setShowAddExerciseModal(false);
      setExerciseSearchTerm('');

      if (exerciseListRef.current && scrollPosition !== undefined) {
        requestAnimationFrame(() => {
          exerciseListRef.current.scrollTop = scrollPosition;
          requestAnimationFrame(() => {
            setShowAddExerciseModal(false);
          });
        });
      } else {
        setShowAddExerciseModal(false);
      }

    } catch (error) {
      setError("Failed to add exercise");
      console.error("Error adding exercise:", error);
    }
  };

  const openAddExerciseModal = useCallback((context) => {
    setExerciseModalContext(context);
    setShowExerciseModal(true);
    setShowNewExerciseForm(false);
    setNewExerciseData({
      name: '',
      is_isolated: false,
      category: 'Freeweight'
    });
    setExerciseSearchTerm('');
  }, []);

  const handleSetCompletion = async (exIndex, setIndex) => {
    try {
      const updatedWorkout = { ...activeWorkout };
      const exercise = updatedWorkout.exercises[exIndex];
      const set = exercise.sets[setIndex];

      set.completed = !set.completed;

    if (set.completed) {
      set.completedWeight = set.completedWeight || set.targetWeight;
      set.completedReps = set.completedReps || set.targetReps;
    }

    const logs = await getCurrentWorkoutLogs(updatedWorkout.id);

    // Find log entry by matching both exercise_id and exercise_index
    const logEntry = logs.find(log => 
      log.exercise_id === exercise.id && 
      log.exercise_index === exIndex
    );

    if (!logEntry) {
      throw new Error(`Log entry not found for exercise ${exercise.name} at index ${exIndex}`);
    }

    const sets = await getCurrentSets(logEntry.id);
    const setToUpdate = sets[setIndex];

    if (!setToUpdate) {
      throw new Error("Set not found in database");
    }

    await updateCurrentSet(setToUpdate.id, {
      weight: set.completed ? set.completedWeight : set.targetWeight,
      reps: set.completed ? set.completedReps : set.targetReps,
      completed: set.completed
    });

    const totalWeight = sets.reduce((sum, s) =>
      sum + (s.completed ? (s.weight || 0) * (s.reps || 0) : 0), 0);

    await updateCurrentWorkoutLog(logEntry.id, {
      total_weight_lifted: totalWeight
    });

    setActiveWorkout(updatedWorkout);
    
    await saveLastExercisePerformance(exercise.id, exercise.sets);
    await cleanupExercisePerformanceData();

  } catch (error) {
    console.error("Error updating set:", error);
    setError(`Failed to update set: ${error.message}`);
  }
};

  const handleSetPartial = async (exIndex, setIndex) => {
    try {
      const updatedWorkout = { ...activeWorkout };
      const exercise = updatedWorkout.exercises[exIndex];
      const set = exercise.sets[setIndex];

      // Toggle just the partial status - doesn't affect completion status
      set.partial = !set.partial;

      const logs = await getCurrentWorkoutLogs(updatedWorkout.id);

      // Find the log entry
      const logEntry = logs.find(log =>
        log.exercise_id === exercise.id &&
        log.exercise_index === exIndex
      );

      if (!logEntry) throw new Error("Log entry not found");

      const sets = await getCurrentSets(logEntry.id);
      const setToUpdate = sets[setIndex];

      if (!setToUpdate) throw new Error("Set not found");

      // Update only the partial status in database
      await updateCurrentSet(setToUpdate.id, {
        partial: set.partial,  // Only update this field
        // Preserve all other existing values
        weight: setToUpdate.weight,
        reps: setToUpdate.reps,
        completed: setToUpdate.completed,
        drop_set_group: setToUpdate.drop_set_group
      });

      setActiveWorkout(updatedWorkout);
    } catch (error) {
      console.error("Error updating partial status:", error);
      setError("Failed to update partial status");
    }
  };

  const handleTemplateSetPartial = (exIndex, setIndex) => {
    const updatedTemplate = { ...editedTemplate };
    const set = updatedTemplate.exercises[exIndex].sets[setIndex];
    set.partial = !set.partial;
    
    setEditedTemplate(updatedTemplate);
  };

  const handleSetNumberClick = async (exIndex, setIndex) => {
    try {
      const updatedWorkout = { ...activeWorkout };
      const exercise = updatedWorkout.exercises[exIndex];
      const set = exercise.sets[setIndex];

      // Toggle between normal set and drop set
      if (set.drop_set_group === 0) {
        // Convert to drop set - inherit from previous set
        const prevSet = setIndex > 0 ? exercise.sets[setIndex - 1] : null;
        set.drop_set_group = prevSet?.drop_set_group || setIndex + 1;
        
        if (prevSet) {
          set.targetWeight = prevSet.targetWeight;
          set.targetReps = prevSet.targetReps;
          if (set.completed) {
            set.completedWeight = prevSet.completedWeight;
            set.completedReps = prevSet.completedReps;
          }
        }
      } else {
        // Convert back to normal set
        set.drop_set_group = 0;
      }

      const logs = await getCurrentWorkoutLogs(updatedWorkout.id);
      const logEntry = logs.find(log => 
        log.exercise_id === exercise.id && 
        log.exercise_index === exIndex
      );

      if (!logEntry) throw new Error("Log entry not found");

      const sets = await getCurrentSets(logEntry.id);
      const setToUpdate = sets[setIndex];

      if (!setToUpdate) throw new Error("Set not found");

      await updateCurrentSet(setToUpdate.id, {
        drop_set_group: set.drop_set_group,
        weight: set.targetWeight,
        reps: set.targetReps,
        completed: set.completed
      });

      setActiveWorkout(updatedWorkout);
    } catch (error) {
      console.error("Error updating drop set:", error);
      setError("Failed to update drop set status");
    }
  };

  const handleTemplateSetNumberClick = (exIndex, setIndex) => {
    const updatedTemplate = { ...editedTemplate };
    const set = updatedTemplate.exercises[exIndex].sets[setIndex];

    // Toggle between normal set and drop set
    if (set.drop_set_group === 0) {
      // Convert to drop set - inherit from previous set
      const prevSet = setIndex > 0 ? updatedTemplate.exercises[exIndex].sets[setIndex - 1] : null;
      set.drop_set_group = prevSet?.drop_set_group || setIndex + 1;
      
      if (prevSet) {
        set.weight = prevSet.weight;
        set.reps = prevSet.reps;
      }
    } else {
      // Convert back to normal set
      set.drop_set_group = 0;
    }

    setEditedTemplate(updatedTemplate);
  };

  const handleCompleteWorkout = async () => {
    try {
      if (!activeWorkout) throw new Error("No active workout to complete");

      // Don't set original template for freestyle workouts
      if (activeWorkout.name !== "Freestyle Workout") {
        const templateUsed = workoutTemplates.find(t =>
          t.name === activeWorkout.name.replace(/ \(\d+\)$/, '')
        );

        if (templateUsed) {
          setOriginalTemplate(templateUsed);

          // Compare with original template to detect changes
          const templateExercises = getWorkoutTemplatesExercises(workoutTemplatesExercises, templateUsed.id);
          const changes = {
            exercisesAdded: Math.max(0, activeWorkout.exercises.length - templateExercises.length),
            exercisesRemoved: Math.max(0, templateExercises.length - activeWorkout.exercises.length),
            setsChanged: 0
          };

          // Check for sets changes (number of sets per exercise)
          templateExercises.forEach((templateEx, index) => {
            if (index < activeWorkout.exercises.length) {
              const currentEx = activeWorkout.exercises[index];
              if (currentEx.sets.length !== templateEx.set_details.length) {
                changes.setsChanged++;
              }
            }
          });

          setTemplateChanges(changes);
        }
      } else {
        // For freestyle workouts, reset any template-related state
        setOriginalTemplate(null);
        setTemplateChanges({
          exercisesAdded: 0,
          exercisesRemoved: 0,
          setsChanged: 0
        });
      }

      setUpdatedWorkoutName(activeWorkout.name);
      setShowCompletionModal(true);

    } catch (error) {
      console.error("Error preparing completion modal:", error);
      setError("Failed to prepare workout completion");
    }
  };

  const confirmCompleteWorkout = async () => {
    try {
      if (!activeWorkout) throw new Error("No active workout to complete");
  
      // Handle template updates if requested
      if (templateAction === 'update' && originalTemplate) {
        await updateWorkoutTemplate(originalTemplate.id);
      } else if (templateAction === 'create') {
        await createNewTemplateFromWorkout();
      }
  
      // Get all data we need before starting transactions
      const session = await getCurrentWorkoutSession(activeWorkout.id);
      if (!session) throw new Error("No session found");
      const logs = await getCurrentWorkoutLogs(activeWorkout.id);
  
      // Pre-fetch all sets before transaction
      const logsWithSets = await Promise.all(
        logs.map(async log => ({
          ...log,
          sets: await getCurrentSets(log.id)
        }))
      );
  
      // Get new session ID
      const newSessionId = (await getMaxSessionId()) + 1;
  
      // Use session date as fallback if startWorkoutDate is null
      const workoutStartDate = startWorkoutDate || new Date(activeWorkout.startedAt);
      const now = getCurrentUTCDate();
      const secondsDifference = Math.floor((now - workoutStartDate) / 1000);
  
      // Update session name if changed
      const finalSessionName = updatedWorkoutName.trim() || activeWorkout.name;
  
      // Save to workout history - we'll do this in a single transaction
      const db = await openDB();
  
      // First save the session
      await new Promise((resolve, reject) => {
        const transaction = db.transaction(["workout_sessions"], "readwrite");
        const store = transaction.objectStore("workout_sessions");
        const { id: _, ...sessionWithoutId } = session;
        
        store.add({
          ...sessionWithoutId,
          session_name: finalSessionName,
          session_date: workoutStartDate.toISOString(),
          duration: Math.floor(secondsDifference / 60)
        }).onsuccess = () => resolve();
  
        transaction.onerror = (error) => reject(error);
      });

      // Then save all logs and sets in a separate transaction
      await new Promise(async (resolve, reject) => {
        const transaction = db.transaction(["workout_log", "sets"], "readwrite");

        transaction.onerror = (error) => {
          console.error("Transaction error:", error);
          reject(error);
        };

        const logStore = transaction.objectStore("workout_log");
        const setsStore = transaction.objectStore("sets");

        // Save all logs first
        for (const log of logsWithSets) {
          const { id: logId, sets, ...logWithoutId } = log;

          try {
            const newLogId = await new Promise((logResolve, logReject) => {
              const request = logStore.add({
                ...logWithoutId,
                session_id: newSessionId
              });

              request.onsuccess = () => logResolve(request.result);
              request.onerror = (error) => logReject(error);
            });

            // Then save all sets for this log
            for (const set of sets) {
              const { id: setId, ...setWithoutId } = set;

              await new Promise((setResolve, setReject) => {
                const setRequest = setsStore.add({
                  ...setWithoutId,
                  workout_log_id: newLogId
                });

                setRequest.onsuccess = () => setResolve();
                setRequest.onerror = (error) => setReject(error);
              });
            }
          } catch (error) {
            console.error("Error saving log or sets:", error);
            reject(error);
            return;
          }
        }

        transaction.oncomplete = () => resolve();
      });

      // Clear current workout data
      await clearCurrentWorkoutData();
      setActiveWorkout(null);
      setShowCompletionModal(false);

    } catch (error) {
      console.error("Error completing workout:", error);
      setError(`Failed to complete workout: ${error.message}`);
    }
  };

  const updateWorkoutTemplate = async (templateId) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(["workout_templates", "workout_template_exercises"], "readwrite");

      // Update template name if changed
      if (updatedWorkoutName !== activeWorkout.name) {
        const templateStore = transaction.objectStore("workout_templates");
        const template = await new Promise(resolve => {
          templateStore.get(templateId).onsuccess = e => resolve(e.target.result);
        });

        if (template) {
          template.name = updatedWorkoutName;
          templateStore.put(template);
        }
      }

      // Update template exercises
      const exercisesStore = transaction.objectStore("workout_template_exercises");

      // Clear existing exercises
      await new Promise(resolve => {
        const clearRequest = exercisesStore.index("template_id").openCursor(IDBKeyRange.only(templateId));
        clearRequest.onsuccess = e => {
          const cursor = e.target.result;
          if (cursor) {
            cursor.delete();
            cursor.continue();
          } else {
            resolve();
          }
        };
      });

      // Add new exercises (with auto-incremented IDs)
      await Promise.all(activeWorkout.exercises.map((exercise, index) => {
        const setDetails = exercise.sets.map(set => ({
          weight: set.targetWeight,
          reps: set.targetReps,
          partial: set.partial || false
        }));

        return new Promise(resolve => {
          exercisesStore.add({
            template_id: templateId,
            exercise_id: exercise.id,
            sets_count: exercise.sets.length,
            set_details: setDetails,
            exercise_index: index
          }).onsuccess = resolve;
        });
      }));

      await new Promise((resolve, reject) => {
        transaction.oncomplete = resolve;
        transaction.onerror = () => reject(new Error("Template update failed"));
      });

    } catch (error) {
      console.error("Error updating template:", error);
      throw error;
    }
  };

  const createNewTemplateFromWorkout = async () => {
    try {
      const db = await openDB();
      const transaction = db.transaction(["workout_templates", "workout_template_exercises"], "readwrite");

      const templatesStore = transaction.objectStore("workout_templates");
      const exercisesStore = transaction.objectStore("workout_template_exercises");

      // Add new template (ID will auto-increment)
      const templateId = await new Promise((resolve, reject) => {
        const request = templatesStore.add({
          name: updatedWorkoutName,
          description: ''
        });
        request.onsuccess = () => resolve(request.result); // Returns the auto-generated ID
        request.onerror = () => reject(new Error("Failed to add template"));
      });

      // Add exercises (IDs will auto-increment)
      await Promise.all(activeWorkout.exercises.map((exercise, index) => {
        const setDetails = exercise.sets.map(set => ({
          weight: set.targetWeight,
          reps: set.targetReps,
          partial: set.partial || false
        }));

        return new Promise((resolve, reject) => {
          const request = exercisesStore.add({
            template_id: templateId,
            exercise_id: exercise.id,
            sets_count: exercise.sets.length,
            set_details: setDetails,
            exercise_index: index
          });
          request.onsuccess = resolve;
          request.onerror = () => reject(new Error("Failed to add exercise"));
        });
      }));

      await new Promise((resolve, reject) => {
        transaction.oncomplete = resolve;
        transaction.onerror = () => reject(new Error("Transaction failed"));
      });

      // Refresh data
      setWorkoutTemplates(await getIndexedDBData("workout_templates"));
      setWorkoutTemplatesExercises(await getIndexedDBData("workout_template_exercises"));

    } catch (error) {
      console.error("Error creating template:", error);
      throw error;
    } finally {
      setIsNewTemplate(false);
    }
  };

  const handleBackToWorkouts = () => {
    setActiveWorkout(null);
  };

  const handleEditWorkout = async (templateId) => {
    try {
      const template = workoutTemplates.find(t => t.id === templateId);
      if (!template) return;

      const templateExercises = workoutTemplatesExercises
        .filter(ex => ex.template_id === templateId)
        .sort((a, b) => a.exercise_index - b.exercise_index);

      const exercisesWithDetails = templateExercises.map(exercise => {
        const exDetails = exercises.find(e => e.id === exercise.exercise_id);
        return {
          id: exercise.exercise_id,
          name: exDetails?.name || `Exercise ${exercise.exercise_id}`,
          sets: exercise.set_details.map((set, i) => ({
            setNumber: i + 1,
            weight: set.weight,
            reps: set.reps,
            partial: set.partial || false,
            drop_set_group: set.drop_set_group || 0
          }))
        };
      });

      setEditedTemplate({
        id: template.id,
        name: template.name,
        description: template.description,
        exercises: exercisesWithDetails
      });

      setEditingTemplate(template);
      setShowTemplateEditor(true);
    } catch (error) {
      console.error("Error preparing template for editing:", error);
      setError("Failed to load template for editing");
    }
  };

  const handleDeleteLastSet = async (exIndex) => {
    try {
      const updatedWorkout = { ...activeWorkout };
      const exercise = updatedWorkout.exercises[exIndex];
      
      // Get the log entry for this exercise
      const logs = await getCurrentWorkoutLogs(activeWorkout.id);
      const logEntry = logs.find(log => 
        log.exercise_id === exercise.id && 
        log.exercise_index === exIndex
      );
  
      if (!logEntry) throw new Error("Log entry not found");
  
      if (exercise.sets.length <= 1) {
        // Delete the entire exercise
        // First delete all sets for this exercise
        const sets = await getCurrentSets(logEntry.id);
        await Promise.all(sets.map(set => deleteCurrentSet(set.id)));
        
        // Then delete the log entry
        const db = await openDB();
        await new Promise((resolve, reject) => {
          const transaction = db.transaction(["current_workout_log"], "readwrite");
          const store = transaction.objectStore("current_workout_log");
          const request = store.delete(logEntry.id);
  
          request.onsuccess = resolve;
          request.onerror = reject;
        });
  
        // Remove exercise from UI state
        updatedWorkout.exercises.splice(exIndex, 1);
        
        // Update exercise indices for remaining exercises
        for (let i = exIndex; i < updatedWorkout.exercises.length; i++) {
          const updatedLog = logs.find(log => 
            log.exercise_id === updatedWorkout.exercises[i].id && 
            log.exercise_index === i + 1 // Because we removed one before this
          );
          
          if (updatedLog) {
            await updateCurrentWorkoutLog(updatedLog.id, {
              exercise_index: i
            });
          }
        }
      } else {
        // Just delete the last set
        const sets = await getCurrentSets(logEntry.id);
        const setToDelete = sets[sets.length - 1];
        
        if (!setToDelete) throw new Error("Set not found in database");
        await deleteCurrentSet(setToDelete.id);
  
        await updateCurrentWorkoutLog(logEntry.id, {
          sets_count: logEntry.sets_count - 1
        });
  
        // Update UI state
        updatedWorkout.exercises[exIndex].sets = exercise.sets.slice(0, -1);
      }
  
      setActiveWorkout(updatedWorkout);
    } catch (error) {
      console.error("Error deleting set:", error);
      setError(`Failed to delete set: ${error.message}`);
    }
  };

  const handleAddNewCustomExercise = () => addNewCustomExercise(
    newExerciseData,
    exerciseModalContext,
    activeWorkout,
    exercises,
    setExercises,
    setActiveWorkout,
    setEditedTemplate,
    setShowExerciseModal,
    setShowNewExerciseForm,
    setNewExerciseData,
    setError
  );

  const closeModal = () => {
    setShowAddExerciseModal(false);
    setExerciseSearchTerm('');
    setShowNewExerciseForm(false);
    setSelectedPrimaryMuscles([]);
    setSelectedSecondaryMuscles([]);
    setNewExerciseData({
      name: '',
      is_isolated: false,
      category: 'Freeweight',
      primaryMuscles: [],
      secondaryMuscles: []
    });
  };

  if (isLoading) {
    return <div className="page-content">Loading workout data...</div>;
  }

  if (error) {
    return (
      <div className="page-content">
        <div className="error-message">{error}</div>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  const handleSaveNotes = async (exIndex) => {
    try {
      const updatedWorkout = { ...activeWorkout };
      const exercise = updatedWorkout.exercises[exIndex];
      
      const logs = await getCurrentWorkoutLogs(updatedWorkout.id);
      const logEntry = logs.find(log => 
        log.exercise_id === exercise.id && 
        log.exercise_index === exIndex
      );
  
      if (logEntry) {
        await updateCurrentWorkoutLog(logEntry.id, {
          notes: currentExerciseNotes
        });
        
        updatedWorkout.exercises[exIndex].notes = currentExerciseNotes;
        setActiveWorkout(updatedWorkout);
      }
  
      setShowNotesModal(false);
    } catch (error) {
      console.error("Error saving notes:", error);
      setError("Failed to save notes");
    }
  };


  const ExerciseSelectionModal = ({
    showModal,
    onClose,
    exercises,
    onSelectExercise,
    onCreateNewExercise,
    newExerciseData,
    setNewExerciseData,
    exerciseSearchTerm,
    setExerciseSearchTerm,
    muscles
  }) => {

    const filteredExercises = exercises.filter(exercise =>
      exercise.name.toLowerCase().includes(exerciseSearchTerm.toLowerCase())
    );

    const toggleExerciseSelection = (exercise) => {
      setSelectedExercises(prev => 
        prev.some(e => e.id === exercise.id)
          ? prev.filter(e => e.id !== exercise.id)
          : [...prev, exercise]
      );
    };

    const handleCreateAndSelectExercise = async () => {
    try {
      if (!newExerciseData.name.trim()) {
        setError("Exercise name is required");
        return;
      }

      // Distribute percentages before saving (70% to primary, 30% to secondary)
      const distributedData = {
        ...newExerciseData,
        primaryMuscles: newExerciseData.primaryMuscles.map(id => ({
        muscle_id: id,
        percent: 70 / newExerciseData.primaryMuscles.length
      })),
      secondaryMuscles: newExerciseData.secondaryMuscles.map(id => ({
        muscle_id: id,
        percent: 30 / newExerciseData.secondaryMuscles.length
      }))
      };

      const db = await openDB();
      const exerciseId = await new Promise((resolve, reject) => {
        const transaction = db.transaction(["exercises"], "readwrite");
        const exerciseStore = transaction.objectStore("exercises");
        
        const newExercise = {
          name: distributedData.name.trim(),
          is_isolated: distributedData.is_isolated,
          category: distributedData.category
        };

        const request = exerciseStore.add(newExercise);
        
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(new Error("Failed to create exercise"));
      });

      await saveExerciseMuscles(
        exerciseId,
        distributedData.primaryMuscles,
        distributedData.secondaryMuscles
      );

      // Create the new exercise object
      const newExerciseObj = {
        id: exerciseId,
        name: distributedData.name.trim(),
        is_isolated: distributedData.is_isolated,
        category: distributedData.category
      };

      // Add to selected exercises using the prop setter
      setSelectedExercises(prev => [...prev, newExerciseObj]);
      
      // Update exercises list in parent
      setExercises(prev => [...prev, newExerciseObj]);

      // Reset form but stay in exercise creation
      setNewExerciseData({
        name: '',
        is_isolated: false,
        category: 'Freeweight',
        primaryMuscles: [],
        secondaryMuscles: []
      });
      setSelectedPrimaryMuscles([]);
      setSelectedSecondaryMuscles([]);
      setShowNewExerciseForm(false);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error creating exercise:", error);
      setError(`Failed to create exercise: ${error.message}`);
    }
  };

    const handleSaveSelectedExercises = async () => {
      try {
        if (exerciseModalContext === 'workout') {
          const updatedExercises = [...activeWorkout.exercises];
          const newExerciseIndices = [];
          
          // First add all exercises to state with temporary data
          selectedExercises.forEach((exercise) => {
            const newIndex = updatedExercises.length;
            newExerciseIndices.push(newIndex);
            
            updatedExercises.push({
              id: exercise.id,
              name: exercise.name,
              exerciseIndex: newIndex, // Track the index
              sets: [] // Temporary empty array
            });
          });

          // Update state immediately to reflect new exercises
          setActiveWorkout(prev => ({
            ...prev,
            exercises: updatedExercises
          }));

          // Now save to database with correct indices
          await Promise.all(selectedExercises.map(async (exercise, i) => {
            const lastPerformance = await getLastExercisePerformance(exercise.id);
            const defaultSets = lastPerformance?.sets || [{
              weight: 0,
              reps: 0,
              partial: false,
              drop_set_group: 0
            }];

            const logEntry = {
              session_id: activeWorkout.id,
              exercise_id: exercise.id,
              sets_count: defaultSets.length,
              total_weight_lifted: 0,
              notes: "",
              exercise_index: newExerciseIndices[i] // Use the correct index
            };

            const logId = await saveCurrentWorkoutLog(logEntry);

            await Promise.all(defaultSets.map(set =>
              saveCurrentSet({
                workout_log_id: logId,
                weight: set.weight,
                reps: set.reps,
                drop_set_group: set.drop_set_group || 0,
                partial: set.partial || false,
                completed: false
              })
            ));

            // Update the exercise in state with actual sets
            setActiveWorkout(prev => {
              const newExercises = [...prev.exercises];
              newExercises[newExerciseIndices[i]] = {
                ...newExercises[newExerciseIndices[i]],
                sets: defaultSets.map((set, i) => ({
                  setNumber: i + 1,
                  targetWeight: set.weight,
                  targetReps: set.reps,
                  completedWeight: null,
                  completedReps: null,
                  completed: false,
                  partial: set.partial || false,
                  drop_set_group: set.drop_set_group || 0
                }))
              };
              return { ...prev, exercises: newExercises };
            });
          }));
        } else {
          // Template editing logic remains the same
          const newExercises = selectedExercises.map(exercise => ({
            id: exercise.id,
            name: exercise.name,
            sets: [{
              setNumber: 1,
              weight: 0,
              reps: 0,
              partial: false,
              drop_set_group: 0
            }]
          }));
          
          setEditedTemplate(prev => ({
            ...prev,
            exercises: [...prev.exercises, ...newExercises]
          }));
        }
        
        setSelectedExercises([]);
        onClose();
      } catch (error) {
        console.error("Error saving selected exercises:", error);
        setError("Failed to add exercises. Please try again.");
      }
    };

    // const [selectedPrimaryMuscles, setSelectedPrimaryMuscles] = useState([]);
    // const [selectedSecondaryMuscles, setSelectedSecondaryMuscles] = useState([]);

    const togglePrimaryMuscle = (muscleId) => {
      setSelectedPrimaryMuscles(prev => 
        prev.includes(muscleId) 
          ? prev.filter(id => id !== muscleId) 
          : [...prev, muscleId]
      );
      
      setNewExerciseData(prev => ({
        ...prev,
        primaryMuscles: prev.primaryMuscles?.includes(muscleId)
          ? prev.primaryMuscles.filter(id => id !== muscleId)
          : [...(prev.primaryMuscles || []), muscleId],
        secondaryMuscles: prev.secondaryMuscles?.filter(id => id !== muscleId) || []
      }));
    };

    const toggleSecondaryMuscle = (muscleId) => {
      // Don't allow if already primary
      if (newExerciseData.primaryMuscles?.includes(muscleId)) return;
      
      setSelectedSecondaryMuscles(prev => 
        prev.includes(muscleId)
          ? prev.filter(id => id !== muscleId)
          : [...prev, muscleId]
      );
      
      setNewExerciseData(prev => ({
        ...prev,
        secondaryMuscles: prev.secondaryMuscles?.includes(muscleId)
          ? prev.secondaryMuscles.filter(id => id !== muscleId)
          : [...(prev.secondaryMuscles || []), muscleId]
      }));
    };

    const goToNextPage = () => {
      if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
      }
    };

    const goToPreviousPage = () => {
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
    };

    const renderFormPage = () => {
      switch (currentPage) {
        case 1:
          return (
            <div className="form-page">
              <h3 className="subtitles">Create New Exercise:</h3>
              <div className="form-group">
                    <h3 className="subtitles">Type:</h3>
                    <div
                      className={`toggle-switch ${newExerciseData.is_isolated ? 'compound' : 'compoundisolated'}`}
                      onClick={() => setNewExerciseData({
                        ...newExerciseData,
                        is_isolated: !newExerciseData.is_isolated
                      })}
                      role="switch"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          setNewExerciseData({
                            ...newExerciseData,
                            is_isolated: !newExerciseData.is_isolated
                          });
                        }
                      }}
                      aria-checked={newExerciseData.is_isolated}
                    >
                      <span className="label-isolated">Isolated</span>
                      <span className="toggle-thumb"></span>
                      <span className="label-compound">Compound</span>
                    </div>
                  </div>

                  <div className="form-group">
                    <h3 className="subtitles">Name:</h3>
                    <input
                      type="text"
                      value={newExerciseData.name}
                      onChange={(e) => setNewExerciseData({
                        ...newExerciseData,
                        name: e.target.value
                      })}
                      placeholder="Enter exercise name"
                      className="exercise-name-input"
                      required
                      autoFocus
                    />
                  </div>

                  <div className="form-group">
                    <h3 className="subtitles">Category:</h3>
                    <select
                      value={newExerciseData.category}
                      onChange={(e) => setNewExerciseData({
                        ...newExerciseData,
                        category: e.target.value
                      })}
                    >
                      <option value="Freeweight">Freeweight</option>
                      <option value="Machine">Machine</option>
                      <option value="Cable">Cable</option>
                      <option value="Bodyweight">Bodyweight</option>
                      <option value="other">Other (specify)</option>
                    </select>

                    {newExerciseData.category === 'other' && (
                      <input
                        type="text"
                        placeholder="Enter custom category"
                        value={newExerciseData.customCategory || ''}
                        onChange={(e) => setNewExerciseData({
                          ...newExerciseData,
                          category: e.target.value
                        })}
                      />
                    )}
                  </div>

                  <div className="button-box">
                    <button
                      onClick={closeModal}
                      className="cancel-button"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={goToNextPage}
                      className="edit-button"
                      disabled={!newExerciseData.name.trim()}
                    >
                      Next
                    </button>
                  </div>
            </div>
          );
        case 2:
          return (
            <div className="form-page">
              <h3 className="subtitles">Create New Exercise:</h3>
                  <div className="muscle-selection-section">
                    <h3 className="subtitles">Primary Muscles Worked</h3>
                    <div className="muscle-tags">
                      {muscles.map(muscle => (
                        <button
                          key={muscle.id}
                          className={`muscle-tag ${
                            selectedPrimaryMuscles.includes(muscle.id) ? 'selected' : ''
                          } ${
                            selectedSecondaryMuscles.includes(muscle.id) ? 'disabled' : ''
                          }`}
                          onClick={() => {
                            if (!selectedSecondaryMuscles.includes(muscle.id)) {
                              togglePrimaryMuscle(muscle.id);
                            }
                          }}
                          disabled={selectedSecondaryMuscles.includes(muscle.id)}
                        >
                          {muscle.name}
                        </button>
                      ))}
                    </div>

                    <h3 className="subtitles">Secondary Muscles Worked</h3>
                    <div className="muscle-tags">
                      {muscles.map(muscle => (
                        <button
                          key={muscle.id}
                          className={`muscle-tag ${
                            selectedSecondaryMuscles.includes(muscle.id) ? 'selected' : ''
                          } ${
                            selectedPrimaryMuscles.includes(muscle.id) ? 'disabled' : ''
                          }`}
                          onClick={() => {
                            if (!selectedPrimaryMuscles.includes(muscle.id)) {
                              toggleSecondaryMuscle(muscle.id);
                            }
                          }}
                          disabled={selectedPrimaryMuscles.includes(muscle.id)}
                        >
                          {muscle.name}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="button-box">
                    <button
                      onClick={goToPreviousPage}
                      className="cancel-button"
                    >
                      Back
                    </button>
                    <button
                      onClick={goToNextPage}
                      className="edit-button"
                      disabled={!newExerciseData.name.trim()}
                    >
                      Next
                    </button>
                  </div>
            </div>
          );
        case 3:
          return (
            <div className="form-page">
              <h3>Save new Exercise and add to workout</h3>
              <div>You can further Edit your Exercise in Settings.</div>

              <div className="button-box">
                    <button
                      onClick={goToPreviousPage}
                      className="cancel-button"
                    >
                      Back
                    </button>
              <button
                    onClick={handleCreateAndSelectExercise}
                    className="add-new-button"
                    disabled={!newExerciseData.name.trim()}
                  >
                    Create & Select
                  </button>
                  </div>
            </div>
          );
          
        default:
          return null;
      }
    };

    return (
      <div className="modal-overlay">
        <div className="exercise-selection-modal">
        <div className="modal-wrapper">
          <div className="modal-content">
            <h3>{showNewExerciseForm ? 'Create New Exercise' : 'Add Exercise'}</h3>

            {!showNewExerciseForm ? (
              <>
                <div className="exercise-search-container">
                  <div className="search-input-container">
                    <FaSearch className="search-icon" />
                    <input
                      type="text"
                      placeholder="Search exercises..."
                      value={exerciseSearchTerm}
                      onChange={(e) => setExerciseSearchTerm(e.target.value)}
                      className="search-input"
                      autoFocus
                      key="exercise-search-input"
                    />
                  </div>
                </div>

                <div 
                  className="exercise-list-container"
                  ref={exerciseListRef}
                  onScroll={handleExerciseListScroll}
                >
                  {filteredExercises.map(exercise => (
                    <div
                      key={exercise.id}
                      data-exercise-id={exercise.id}
                      className={`exercise-option ${
                        selectedExercises.some(e => e.id === exercise.id) ? 'selected' : ''
                      }`}
                      onClick={() => {
                        setSelectedExercises(prev => 
                          prev.some(e => e.id === exercise.id)
                            ? prev.filter(e => e.id !== exercise.id)
                            : [...prev, exercise]
                        );
                      }}
                    >
                      {exercise.name}
                      {selectedExercises.some(e => e.id === exercise.id) && (
                        <span className="selection-checkmark">✓</span>
                      )}
                    </div>
                  ))}
                </div>
                {selectedExercises.length > 0 && (
                  <div className="selected-exercises-tags">
                    {selectedExercises.map(exercise => (
                      <div key={exercise.id} className="exercise-tag">
                        {exercise.name}
                        <button 
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedExercises(prev => 
                              prev.filter(e => e.id !== exercise.id)
                            );
                          }}
                          className="remove-tag-button"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                <div className="modal-actions">
                  <button
                    onClick={() => setShowNewExerciseForm(true)}
                    className="add-new-button"
                  >
                    Can't find your exercise? Create New
                  </button>
                </div>
                <div className="modal-actions">
                    <button
                      onClick={() => {
                        setSelectedExercises([]);
                        onClose();
                      }}
                      className="delete-set-button"
                    >
                      Cancel
                    </button>
                    {selectedExercises.length > 0 && (
                      <button
                        onClick={handleSaveSelectedExercises}
                        className="add-set-button"
                      >
                        Add Selected ({selectedExercises.length})
                      </button>
                    )}
                </div>
              </>
            ) : (
              <>
                <div className="modal-overlay">
                  <div className="modal-wrapper">
                    <div className="modal-content">
                      {renderFormPage()}
                    </div>
                  </div>
                </div>
                <div className="modal-actions">
                  <button
                    onClick={() => {
                      setShowNewExerciseForm(false);
                      // Maintain selected exercises when going back
                      setTimeout(() => {
                        const searchInput = document.querySelector('.search-input');
                        if (searchInput) searchInput.focus();
                      }, 0);
                    }}
                    className="back-to-search"
                  >
                    Back to Selection
                  </button>

                  <button
                    onClick={handleCreateAndSelectExercise}
                    className="add-new-button"
                    disabled={!newExerciseData.name.trim()}
                  >
                    Create & Select
                  </button>

                  {selectedExercises.length > 0 && (
                    <button
                      onClick={handleSaveSelectedExercises}
                      className="add-set-button"
                    >
                      Add Selected ({selectedExercises.length})
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
          </div>
        </div>
      </div>
    );
  };

  if (activeWorkout) {
    return (
      <div className="page-content active-workout-view">
        <div>
          <div className="top-nav-bar">
            <button onClick={handleBackToWorkouts} className="back-button">
              <FaArrowLeft />
            </button>
            <div className="workout-title-nav">{activeWorkout.name}</div>
            <WorkoutTimer 
            startedAt={activeWorkout?.startedAt} 
            isActive={!!activeWorkout?.startedAt} 
          />
          </div>
        </div>

        <div className={`exercise-bubbles-container ${window.innerWidth < 480 ? 'mobile-stacked' : ''}`}>
          {activeWorkout.exercises.map((exercise, exIndex) => (
            <div key={exIndex} className="exercise-bubble">
              <div className="exercise-header">
                <h3 className="exercise-title">{exercise.name}</h3>
                <button 
                  className="notes-button"
                  onClick={() => {
                    setCurrentExerciseNotes(exercise.notes || '');
                    setCurrentExerciseIndex(exIndex);
                    setShowNotesModal(true);
                  }}
                >
                  {exercise.notes ? 'Edit Notes' : 'Add Notes'}
                </button>
              </div>

              {exercise.notes && (
                <div className="exercise-notes">
                  <p>{exercise.notes}</p>
                </div>
              )}

              <table className="sets-table">
                <thead>
                  <tr>
                    <th>Set</th>
                    <th>Target</th>
                    <th>Kg</th>
                    <th>Reps</th>
                    <th>ROM</th>
                    <th>Done</th>
                  </tr>
                </thead>
                <tbody>
                  {exercise.sets.map((set, setIndex) => (
                    <tr
                      key={setIndex}
                      className={`set-row ${set.completed ? 'completed' : ''}`}
                    >
                      {/* <td>{setIndex + 1}</td> */}
                      <td 
                        className={`set-number ${set.drop_set_group > 0 ? 'drop-set' : ''}`}
                        onClick={() => handleSetNumberClick(exIndex, setIndex)}
                      >
                        {set.drop_set_group > 0 ? 'D' : 
                          setIndex + 1 - exercise.sets.slice(0, setIndex).filter(s => s.drop_set_group > 0).length
                        }
                      </td>
                      <td className="set-target">
                        {set.targetWeight ? `${set.targetWeight}kg × ${set.targetReps}` : `${set.targetReps} reps`}
                      </td>
                      <td>
                        <input
                          type="number"
                          value={set.completedWeight || ''}
                          onChange={(e) => {
                            const updatedWorkout = { ...activeWorkout };
                            updatedWorkout.exercises[exIndex]
                              .sets[setIndex].completedWeight = parseFloat(e.target.value) || 0;
                            setActiveWorkout(updatedWorkout);
                          }}
                          placeholder={set.targetWeight}
                          className="weight-input"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={set.completedReps || ''}
                          onChange={(e) => {
                            const updatedWorkout = { ...activeWorkout };
                            updatedWorkout.exercises[exIndex]
                              .sets[setIndex].completedReps = parseInt(e.target.value) || 0;
                            setActiveWorkout(updatedWorkout);
                          }}
                          placeholder={set.targetReps}
                          className="reps-input"
                        />
                      </td>
                      <td>
                        <button
                          onClick={() => handleSetPartial(exIndex, setIndex)}
                          className={`partial-button ${set.partial ? 'active' : ''}`}
                        >
                          {set.partial ? 'P' : 'F'}
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => handleSetCompletion(exIndex, setIndex)}
                          className={`tick-button ${set.completed ? 'completed' : ''}`}
                        >
                          {set.completed ? '✓' : ''}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="exercise-actions">
              <button 
                className={`delete-set-button ${exercise.sets.length <= 1 ? 'last-set' : ''}`}
                onClick={() => handleDeleteLastSet(exIndex)}
              >
              {exercise.sets.length <= 1 ? 'Delete Exercise' : (<><FaMinusCircle /> Delete Set</>)}
              </button>
              <button
                className="add-set-button"
                onClick={async () => {
                  try {
                    const updatedWorkout = { ...activeWorkout };
                    const newSet = {
                      setNumber: exercise.sets.length + 1,
                      targetWeight: exercise.sets.length > 0
                        ? exercise.sets[exercise.sets.length - 1].targetWeight
                        : 0,
                      targetReps: exercise.sets.length > 0
                        ? exercise.sets[exercise.sets.length - 1].targetReps
                        : 0,
                      completedWeight: null,
                      completedReps: null,
                      completed: false,
                      drop_set_group: 0
                    };

                    updatedWorkout.exercises[exIndex].sets.push(newSet);
                    setActiveWorkout(updatedWorkout);

                    const logs = await getCurrentWorkoutLogs(updatedWorkout.id);
                    const logEntry = logs.find(log => log.exercise_id === exercise.id);

                    if (logEntry) {
                      await updateCurrentWorkoutLog(logEntry.id, {
                        sets_count: logEntry.sets_count + 1
                      });

                      await saveCurrentSet({
                        workout_log_id: logEntry.id,
                        weight: newSet.targetWeight,
                        reps: newSet.targetReps,
                        drop_set_group: newSet.drop_set_group || 0,
                        partial: false,
                        completed: false
                      });
                    }
                  } catch (error) {
                    setError("Failed to add set");
                    console.error("Error adding set:", error);
                  }
                }}
              >
                <FaPlusCircle /> Add Set
              </button>
              </div>
            </div>
          ))}

          <button
            className="add-exercise-button"
            onClick={() => {openAddExerciseModal('workout'); setShowExerciseModal(true);}}
          >
            <FaPlusCircle /> Add Exercise
          </button>
          
          {showExerciseModal && exerciseModalContext === 'workout' && (
            <ExerciseSelectionModal
              showModal={showExerciseModal}
              onClose={() => {
                setShowExerciseModal(false);
                setExerciseSearchTerm('');
                setShowNewExerciseForm(false);
                setSelectedPrimaryMuscles([]);
                setSelectedSecondaryMuscles([]);
                setNewExerciseData({
                  name: '',
                  is_isolated: false,
                  category: 'Freeweight'
                });
                setSelectedExercises([]);
              }}
              exercises={exercises}
              onSelectExercise={handleAddExercise}
              onCreateNewExercise={handleAddNewCustomExercise}
              newExerciseData={newExerciseData}
              setNewExerciseData={setNewExerciseData}
              exerciseSearchTerm={exerciseSearchTerm}
              setExerciseSearchTerm={setExerciseSearchTerm}
              muscles={muscles}
              selectedPrimaryMuscles={selectedPrimaryMuscles}
              setSelectedPrimaryMuscles={setSelectedPrimaryMuscles}
              selectedSecondaryMuscles={selectedSecondaryMuscles}
              setSelectedSecondaryMuscles={setSelectedSecondaryMuscles}
            />
          )}

          {showNotesModal && (
            <div className="notes-modal">
              <div className="modal-content">
                <h3>Notes for {activeWorkout.exercises[currentExerciseIndex]?.name}</h3>
                <textarea
                  value={currentExerciseNotes}
                  onChange={(e) => setCurrentExerciseNotes(e.target.value)}
                  placeholder="Add your notes here..."
                  rows="5"
                />
                <div className="modal-actions">
                  <button
                      onClick={() => setShowNotesModal(false)}
                      className="delete-set-button"
                    >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleSaveNotes(currentExerciseIndex)}
                    className="add-set-button"
                  >
                    Save Notes
                  </button>
                </div>
              </div>
            </div>
          )}

          {showCompletionModal && (
            <div className="modal-overlay">
              <div className="completion-modal">
                <div className="modal-content">
                  <h2>Complete Workout</h2>

                  <div className="form-group align-side">
                    <h3>Workout Name: </h3>
                    <input  
                      type="text"
                      value={updatedWorkoutName}
                      onChange={(e) => setUpdatedWorkoutName(e.target.value)}
                      className="workout-name-input"
                    />
                  </div>

                  <div className="template-options">
                    <h3>Save Options</h3>
                    <div className="template-actions">
                      <ul style={{ listStyle: 'none', padding: 0 }}>
                        <li>
                          <label>
                            <input
                              type="radio"
                              name="templateAction"
                              checked={templateAction === 'none'}
                              onChange={() => setTemplateAction('none')}
                              className="radio-button"
                            />
                            Just save to workout log
                          </label>
                        </li>
                        
                        {/* Only show "Update original template" if this isn't a freestyle workout AND there's an original template */}
                        {originalTemplate && activeWorkout.name !== "Freestyle Workout" && (
                          <li>
                            <label>
                              <input
                                type="radio"
                                name="templateAction"
                                checked={templateAction === 'update'}
                                onChange={() => setTemplateAction('update')}
                                className="radio-button"
                              />
                              Update original template ({originalTemplate.name})
                            </label>
                          </li>
                        )}
                        
                        <li>
                          <label>
                            <input
                              type="radio"
                              name="templateAction"
                              checked={templateAction === 'create'}
                              onChange={() => setTemplateAction('create')}
                              className="radio-button"
                            />
                            Create new template
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="exercise-actions">
                    <button
                      onClick={() => setShowCompletionModal(false)}
                      className="delete-set-button"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={confirmCompleteWorkout}
                      className="add-set-button"
                    >
                      Complete Workout  
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showAddExerciseModal && (
            <div className="modal-overlay">
            <div className="exercise-selection-modal">
              <div className="modal-content">
                <h3>{showNewExerciseForm ? 'Create New Exercise' : 'Add Exercise'}</h3>

                {!showNewExerciseForm ? (
                  <>
                    <input
                      type="text"
                      placeholder="Search exercises..."
                      value={exerciseSearchTerm}
                      onChange={(e) => setExerciseSearchTerm(e.target.value)}
                      className="search-input"
                      autoFocus
                      key="exercise-search-input"
                    />

                    <div 
                      className="exercise-list-container"
                      ref={exerciseListRef}
                    >
                      {filteredExercises.map(exercise => (
                        <div
                          key={exercise.id}
                          className="exercise-option"
                          onClick={() => handleAddExercise(exercise.id)}
                        >
                          {exercise.name}
                        </div>
                      ))}
                    </div>

                    <button
                      onClick={() => setShowNewExerciseForm(true)}
                      className="add-new-button"
                    >
                      Can't find your exercise? Create New
                    </button>
                  </>
                ) : (
                  <>

                    <div className="form-group">
                      <label>
                        <input
                          type="checkbox"
                          checked={newExerciseData.is_isolated}
                          onChange={(e) => setNewExerciseData({
                            ...newExerciseData,
                            is_isolated: e.target.checked
                          })}
                        />
                        Isolated Exercise
                      </label>
                    </div>

                    <div className="form-group">
                      <label>Exercise Name:</label>
                      <input
                        type="text"
                        value={newExerciseData.name}
                        onChange={(e) => setNewExerciseData({
                          ...newExerciseData,
                          name: e.target.value
                        })}
                        placeholder="Enter exercise name"
                        className="exercise-name-input"
                        required
                        autoFocus
                      />
                    </div>
 
                    <div className="form-group">
                      <label>Category:</label>
                      <select
                        value={newExerciseData.category}
                        onChange={(e) => setNewExerciseData({
                          ...newExerciseData,
                          category: e.target.value
                        })}
                      >
                        <option value="Freeweight">Freeweight</option>
                        <option value="Machine">Machine</option>
                        <option value="Cable">Cable</option>
                        <option value="Bodyweight">Bodyweight</option>
                        <option value="other">Other (specify)</option>
                      </select>

                      {newExerciseData.category === 'other' && (
                        <input
                          type="text"
                          placeholder="Enter custom category"
                          value={newExerciseData.customCategory || ''}
                          onChange={(e) => setNewExerciseData({
                            ...newExerciseData,
                            category: e.target.value
                          })}
                        />
                      )}
                    </div>

                    <div className="modal-actions">
                      <button
                        onClick={() => setShowNewExerciseForm(false)}
                        className="back-to-search"
                      >
                        Back to Search
                      </button>

                      <button
                        onClick={handleAddNewCustomExercise}
                        className="add-new-button"
                      >
                        Create Exercise
                      </button>
                    </div>
                  </>
                )}

                <button
                  onClick={closeModal}
                  className="cancel-button"
                >
                  Close
                </button>
              </div>
            </div>
            </div>
          )}
        </div>

        <div className="workout-actions">
          <button
            onClick={handleCompleteWorkout}
            className="complete-workout-button"
          >
            Complete Workout
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
    <div className="page-content">

      {hasActiveWorkout && (
        <div className="workouts-section">
          <h2>Continue Workout</h2>
          <ul className="workout-list">
            <li
            key="continue-workout"
            className="workout-item"
            onClick={() => toggleWorkoutDescription("continue-workout")}
            >
              <div className="workout-header">
                <span className="workout-title">Continue Last Workout</span>
                <div className="icons-container">
                  <FaPlay onClick={async () => {
                const workout = await loadActiveWorkoutFromDB();
                if (workout) {
                  setActiveWorkout(workout);
                }
              }} className="play-icon" />
                </div>
              </div>

              {expandedWorkout === "continue-workout" && (
              <div className="workout-description">
                Resume your workout in progress.
              </div>
            )}
            </li>
          </ul>
        </div>
      )}

      <div className="workouts-section">
        <h2>FreeStyle</h2>
        <ul className="workout-list">
          <li
            key="empty-workout"
            className="workout-item"
            onClick={() => toggleWorkoutDescription("empty-workout")}
          >
            <div className="workout-header">
              <span className="workout-title">Empty Workout</span>
              <div className="icons-container">
                <FaPlay
                  className="play-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    startNewWorkout("empty");
                  }}
                />
              </div>
            </div>

            {expandedWorkout === "empty-workout" && (
              <div className="workout-description">
                Start new workout from fresh.
              </div>
            )}
          </li>
        </ul>
      </div>

      <div className="workouts-section">
        <h2>Workout Plans</h2>
        <ul className="workout-list">
          {workoutTemplates.map((workout) => (
            <li
              key={workout.id}
              className="workout-item"
              onClick={() => toggleWorkoutDescription(workout.id)}
            >
              <div className="workout-header">
                <span className="workout-title">{workout.name}</span>
                <div className="icons-container">
                  <MdEdit
                    className="edit-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditWorkout(workout.id);
                    }}
                  />
                  <FaPlay
                    className="play-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      startNewWorkout(workout.id);
                    }}
                  />
                </div>
              </div>

              {expandedWorkout === workout.id && (
                <div className="workout-description">
                  {workout.description}
                  <div className="exercise-list">
                    {formatExerciseList(exercises, getWorkoutTemplatesExercises(workoutTemplatesExercises, workout.id)).map((item, i) => (
                      <div key={i} className="exercise-item">{item}</div>
                    ))}
                  </div>
                </div>
              )}
            </li>
          ))}

          <li
            className="workout-item create-template"
            key="new-template"
            onClick={() => toggleWorkoutDescription("new-template")}
          >
            <div className="workout-header">
              <span className="workout-title">Create New Template</span>
              <div className="icons-container">
                <FaPlusCircle 
                  onClick={() => {
                    setEditedTemplate({
                      id: Date.now(),
                      name: 'New Workout Template',
                      description: '',
                      exercises: []
                    });
                    setShowTemplateEditor(true);
                    setCurrentPageT(1);
                    setIsNewTemplate(true);
                  }}
                  className="plus-icon" 
                />
              </div>
            </div>
            {expandedWorkout === "new-template" && (
                <div className="workout-description">
                  Start building a custom workout plan
                </div>
              )}
          </li>
        </ul>
      </div>
    </div>

    {showTemplateEditor && (
    <div className="modal-overlay">
      <div className="modal-wrapper">
        <div className="modal-content">
          {renderTemplatePage()}
        </div>
      </div>
    </div>
  )}
    {showExerciseModal && (
        <ExerciseSelectionModal
          showModal={showExerciseModal}
          onClose={() => {
            setShowExerciseModal(false);
            setExerciseSearchTerm('');
            setShowNewExerciseForm(false);
            setSelectedPrimaryMuscles([]);
            setSelectedSecondaryMuscles([]);
            setNewExerciseData({
              name: '',
              is_isolated: false,
              category: 'Freeweight'
            });
            setSelectedExercises([]);
          }}
          exercises={exercises}
          onSelectExercise={(exerciseId) => {
            if (exerciseModalContext === 'workout') {
              handleAddExercise(exerciseId);
            } else {
              // Handle adding to template
              setEditedTemplate(prev => ({
                ...prev,
                exercises: [
                  ...prev.exercises,
                  {
                    id: exerciseId,
                    name: exercises.find(e => e.id === exerciseId)?.name || `Exercise ${exerciseId}`,
                    sets: [{
                      setNumber: 1,
                      weight: 0,
                      reps: 0
                    }]
                  }
                ]
              }));
            }
            setShowExerciseModal(false);
          }}
          onCreateNewExercise={handleAddNewCustomExercise}
          newExerciseData={newExerciseData}
          setNewExerciseData={setNewExerciseData}
          exerciseSearchTerm={exerciseSearchTerm}
          setExerciseSearchTerm={setExerciseSearchTerm}
          exerciseModalContext={exerciseModalContext}
          muscles={muscles}
          selectedPrimaryMuscles={selectedPrimaryMuscles}
          setSelectedPrimaryMuscles={setSelectedPrimaryMuscles}
          selectedSecondaryMuscles={selectedSecondaryMuscles}
          setSelectedSecondaryMuscles={setSelectedSecondaryMuscles}
        />
      )}
    </>
  );
};

export default Workout;